import { SHOW_OTHER } from './types';

export const otherOptionSelected = (name, event) => async dispatch => {
    try {
        dispatch({ type: SHOW_OTHER, payload: { [name]: event.target.checked }});
    } catch (errors) {
      // dispatch({ type: SET_ERRORS, payload: { error: "Unable to get current step" }});
    }
};